"use client";

import { datadogRum, type Context, type RumInitConfiguration } from "@datadog/browser-rum";

let isInitialized = false;

export function initDatadogRum(config: RumInitConfiguration) {
  if (typeof window === "undefined" || isInitialized) return;
  datadogRum.init(config);
  isInitialized = true;
}

export function isDatadogRumInitialized() {
  return isInitialized;
}

export function addAction(name: string, context?: Record<string, unknown>) {
  if (!isInitialized) return;
  datadogRum.addAction(name, context as Context | undefined);
}

export function addError(error: unknown, context?: Record<string, unknown>) {
  if (!isInitialized) return;
  datadogRum.addError(error as any, context as Context | undefined);
}

export function setUser(id: string, extra?: Record<string, unknown>) {
  if (!isInitialized) return;
  datadogRum.setUser({ id, ...(extra || {}) } as any);
}

export function clearUser() {
  if (!isInitialized) return;
  datadogRum.clearUser();
}

